import { hasCapability, type User } from "../base";

export const marketingLead = {
  create: (user: User) => hasCapability(user, "marketingLead.create"),
};
